import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import TagsList from './tagsList';
import TagForm from './tagsForm';
import PageError from '../error/pageError';

export default class TagsOrganization extends React.Component {
    render() {
        const { path } = this.props;

        return (
            <Switch>
                <Route
                    exact
                    path={`${path}/`}
                    render={({ match, history }) => {
                        return <TagsList organization={this.props.organization} match={match} />;
                    }}
                />

                <Route
                    exact
                    path={`${path}/new`}
                    render={({ match, history }) => {
                        return <TagForm organization={this.props.organization} history={history} />;
                    }}
                />

                <Route
                    exact
                    path={`${path}/:tagId`}
                    render={basenameProps => {
                        const tagId = basenameProps.match.params.tagId;
                        return <TagForm tagId={tagId} organization={this.props.organization} history={basenameProps.history} />;
                    }}
                />
                {/* Error */}
                <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${this.props.organization.id}`} />} />
            </Switch>
        );
    }
}

TagsOrganization.propTypes = {
    organization: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
